import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useToaster } from '@components/toaster';
import { useScopedTranslate } from '@locale/translate';

import { createUser, getApplicationData, SubmitError, TriggerDataCreate } from './api';
import locale from './locale.json';

export const useLearnWorldsApplicationData = (applicationId: string) => {
  return useQuery({
    queryKey: ['learn-worlds-application', applicationId],
    queryFn: () => getApplicationData(applicationId),
  });
};

export const useCreateLearnWorldsUser = (applicationId: string) => {
  const { t } = useScopedTranslate(locale);

  const { showError, showSuccess } = useToaster();
  const queryClient = useQueryClient();
  return useMutation((data: TriggerDataCreate) => createUser(applicationId, data), {
    mutationKey: ['learn-worlds-application', applicationId],
    onSuccess: (_, { save }) => {
      showSuccess(save ? t('datasaved') : t('usercreated'));
      queryClient.invalidateQueries(['learn-worlds-application', applicationId]);
      queryClient.invalidateQueries(['application-onboarding-load', applicationId]);
    },
    onError: (error: SubmitError) => {
      showError(
        error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : error.message
            ? error.message
            : t('usernotcreated'),
      );
    },
  });
};
